var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.alerts),function(alert){return _c('div',{key:alert.id,class:[alert.status==='success' ? 'alert-success' : 'alert-danger', 'alert']},[_vm._v(" "+_vm._s(alert.message)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }